import { render, staticRenderFns } from "./swipeItem.vue?vue&type=template&id=6a3b8c80&scoped=true&"
import script from "./swipeItem.vue?vue&type=script&lang=js&"
export * from "./swipeItem.vue?vue&type=script&lang=js&"
import style0 from "./swipeItem.vue?vue&type=style&index=0&id=6a3b8c80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3b8c80",
  null
  
)

export default component.exports